import React, { Component } from 'react'
import { connect } from 'react-redux'
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from 'client/components/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import DialogActions from '@material-ui/core/DialogActions';
import actions from 'client/actions'

const isValidEmail = /^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/g;

class UserDialog extends Component {

  constructor (props) {
    super(props)
    this.state = {
        email: ''
    }
    this.handleCreate = this.handleCreate.bind(this)
    this.handleEmailChange = this.handleEmailChange.bind(this)
  }

  handleCreate () {
    const {dispatch, createUser, current, handleDialog, notifyDanger} = this.props;
    const {email} = this.state;
    if (email && email.match(isValidEmail)) {
        dispatch(createUser(current.id, this.state.email));
        handleDialog();
    } else {
        dispatch(notifyDanger('Ugyldig email', 'Error'));
    }
  }

  handleEmailChange (e) {
    this.setState({email: e.target.value});
  }

  render () {
    return (
        <Dialog fullWidth={true} onClose={this.props.handleDialog} open={this.props.isDialogOpen}>
            <form>
            <DialogTitle onClose={this.props.handleDialog}>
                Opret bruger
            </DialogTitle>
            <DialogContent dividers>
              <input
                label="Email"
                type="email"
                onChange={this.handleEmailChange}
                className="form-control"
                placeholder="Udfyld titel"
                required
              />
            </DialogContent>
            <DialogActions>
                <button type="button" onClick={ this.handleCreate } className="btn btn-primary">
                    Opret
                </button>
            </DialogActions>
            </form>
        </Dialog>
    )
  }
}


const mapStateToProps = state => {
  return {
    current: state.data.plan.current,
    plan: state.data.customer.plan,
  }
}

const mapDispatchToProps = dispatch => ({
  dispatch,
  createUser: actions.createPlanUser,
  notifyDanger: actions.notifyDanger
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(UserDialog)